import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import * as routes from './routes';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Billing from './pages/Billing';
import Devices from './pages/Devices';
import Support from './pages/Support';
import Login from './pages/Login';
import Page404 from './pages/404';
import DeviceActivation from './pages/DeviceActivation';
import AuthProvider from './providers/AuthProvider';

function App() {
  const router = createBrowserRouter([
    {
      path: routes.HOME,
      element: (
        <AuthProvider>
          <Home />
        </AuthProvider>
      ),
    },
    {
      path: routes.PROFILE,
      element: (
        <AuthProvider>
          <Profile />
        </AuthProvider>
      ),
    },
    {
      path: routes.BILLING,
      element: (
        <AuthProvider>
          <Billing />
        </AuthProvider>
      ),
    },
    {
      path: routes.DEVICES,
      element: (
        <AuthProvider>
          <Devices />
        </AuthProvider>
      ),
    },
    {
      path: routes.SUPPORT,
      element: (
        <AuthProvider>
          <Support />
        </AuthProvider>
      ),
    },
    {
      path: routes.LOGIN,
      element: <Login />,
    },
    {
      path: routes.DEVICE_ACTIVATION,
      element: (
        <AuthProvider>
          <DeviceActivation />
        </AuthProvider>
      ),
    },
    {
      path: '*',
      element: <Page404 />,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;
